// Translation data from the original translation.js
export const englishTxt = {
    "title1" : "Save on the most valuable resource : time",
    "title1bis" : "Leverage the Power of AI to Elevate Your Meetings",
    "title2" : "Get keypoints on the go",
    "title3" : "Retrieve your meeting whenever needed",
    "title4" : "Privacy centered",
    "title5" : "Get In Touch",
    "p1" : `Unpen frees you from taking notes and report so that you can focus on getting things done.`,
    "p1bis" : `Unpen is your groundbreaking solution for recording, summarizing, and reporting on in-person meetings with unmatched precision and ease.
            <br/><br/>
            With Unpen, you'll never forget crucial meeting details, decisions, or action items again.`,
    "p2" : `Unpen highlight the important points as the meeting progress.`,
    "p3" : `Unpen allows direct use without installation requirements, making collaboration effortless.
            <br/><br/>
            Share insights with colleagues, customers, or partners via email.
            `,
    "p4" : `<br/>Your meetings are truly yours. <b>Unpen do not sell, share or reuse your datas</b> for any other purpose than providing our service.
            <br/><br/>
            <b>All your datas are stored and processed in the EU.</b> To ensure your datas privacy, every meeting is encrypted on our servers.`,
    "p5" : "Try Unpen for free",
    "calltoaction1" : "Try Unpen for free",
    "submitMail" : "Submit email",
    "features" : "Features",
    "signup" : "Sign up",
    "signin" : "Sign in",
    "legalMention": "Legal information",
    "editor": "Publisher",
    "Hosting": "Hosting",
    "capital": "social capital",
    "FAQ_title1" : "How does Unpen ensure the security and confidentiality of my meetings ?",
    "FAQ_title2" : "Does Unpen share or sell my data to third parties ?",
    "FAQ_title3" : "Where are my data stored, and how does Unpen comply with data protection regulations ?",
    "FAQ_title4" : "What languages does Unpen support ?",
    "FAQ_title5" : "Can I use Unpen offline ?",
    "FAQ_title6" : "What is the maximum duration of a meeting ?",
    "FAQ_title7" : "How can I share a meeting with my colleagues, clients or partners ?",
    "FAQ_text1": "At Unpen, we take data protection very seriously. All meetings transcriptions, summaries, and key points are encrypted in our database, ensuring that only you can access them. We use industry-standard encryption protocols to safeguard your data.",
    "FAQ_text2": "Absolutely not. We respect the confidentiality of your data and do not share or sell it to anyone. Your data is solely used for the purpose of helping you have more productive meetings.",
    "FAQ_text3": "All data processed by Unpen is stored within the European Union (EU) in compliance with the General Data Protection Regulation (GDPR). We adhere to strict data protection policies and procedures to ensure that your personal data is handled responsibly and securely.",
    "FAQ_text4": "The Unpen interface is currently available in English, French and Spanish. However, our AI system can process and understand text in multiple languages, including English, French, German, Spanish, and Italian. We're working on adding more languages to both the interface and our AI models, so stay tuned for updates! Our goal is to make Unpen accessible to users worldwide, regardless of their language preferences.",
    "FAQ_text5": "You can upload audio (or video) files recorded while offline once you go back online and we will transcribe and summarize it as if it was recorded live on Unpen.",
    "FAQ_text6": "There is no limit to the duration of a meeting in Unpen.",
    "FAQ_text7": "You can easily share by mail the meeting's summary, keypoints and/or transcription.",
    "TOS": "Terms of Service",
    "signupButton": "Sign up",
    "TOSCheckbox": "I have read and agree to the <a href='https://unpen.eu/TOS_pdf/en'>TOS</a> and <a href='https://unpen.eu/CGV'>terms of sales</a>.",
    "pswConfirmLabel": "Confirm password",
    "pswLabel": "Password",
    "psw": "Password",
    "psw2": "Confirm password",
    "emailLabel": "Email",
    "email": "My email",
    "SignUpTitle": "Sign Up",
    "hero_title": "Embrace Better Meetings with Unpen",
    "hero_description": "Revolutionize your meetings with AI-powered recording, transcription, and summarization.",
    "get_started": "Get Started",
    "sign_in": "Sign In",
    "sign_up_title": "Sign Up",
    "email_label": "Email",
    "password_label": "Password",
    "submit": "Submit",
    "forgotPassword": "Forgot password?",
    "resetPasswordInstructions": "Enter your email address and we'll send you a link to reset your password.",
    "sendResetLink": "Send reset link",
    "resetLinkSent": "Reset link sent!",
    "checkEmailInstructions": "Please check your email for instructions to reset your password.",
    "backToLogin": "Return to",
    "noAccount": "Don't have an account?",
    "createAccount": "Create account",
    "alreadyHaveAccount": "Already have an account?",
    "faq_title": "Frequently Asked Questions",
    "slide1_title": "Save on the most valuable resource: time",
    "slide1_content": "Unpen frees you from taking notes and reports during your meetings and interviews so that you can focus on getting things done.",
    "slide2_title": "Get keypoints on the go",
    "slide2_content": "Unpen highlight the important points as the meeting progress.",
    "slide3_title": "Privacy centered",
    "slide3_content": "Your meetings are truly yours. Unpen do not sell, share or reuse your datas for any other purpose than providing our service.",
    "faq1_question": "How does Unpen ensure the security and confidentiality of my meetings?",
    "faq1_answer": "At Unpen, we take data protection very seriously. All meetings transcriptions, summaries, and key points are encrypted in our database, ensuring that only you can access them. We use industry-standard encryption protocols to safeguard your data.",
    "faq2_question": "Does Unpen share or sell my data to third parties?",
    "faq2_answer": "Absolutely not. We respect the confidentiality of your data and do not share or sell it to anyone. Your data is solely used for the purpose of helping you have more productive meetings.",
    "faq3_question": "Where are my data stored, and how does Unpen comply with data protection regulations?",
    "faq3_answer": "All data processed by Unpen is stored within the European Union (EU) in compliance with the General Data Protection Regulation (GDPR). We adhere to strict data protection policies and procedures to ensure that your personal data is handled responsibly and securely.",
    "faq4_question": "What languages does Unpen support?",
    "faq4_answer": "The Unpen interface is currently available in English, French and Spanish. However, our AI system can process and understand text in multiple languages, including English, French, German, Spanish, and Italian.",
};

export const frenchTxt = {
	"title1" : "Économisez votre ressource la plus précieuse : votre temps.",
    "title1bis" : "Tirez parti de la puissance de l'IA pour améliorer vos réunions",
    "title2" : "Obtenez les points clés au fur et à mesure de la réunion",
    "title3" : "Vos réunions à portée de main",
    "title4" : "Axé sur la vie privée",
    "title5" : "Inscription",
    "p1" : `Unpen vous libère de la prise de notes et de la rédaction de comptes-rendu afin que vous puissiez vous concentrer sur le reste de votre travail.`,
    "p1bis" : `Unpen est votre solution tout en un pour l'enregistrement, le résumé et la rédaction de compte rendu pour vos réunions en présentiel avec une précision et une
                facilité inégalées.`,
    "p2" : `Unpen met en évidence les points importants à mesure que la réunion progresse.`,
    "p3" : `Vous pouvez accéder et modifier toutes vos réunions à tout moment depuis votre navigateur préféré, aucune installation requise.
            <br/><br/>
            Partagez vos résumés à vos collègues, clients ou partenaires en un clic.
            `,
    "p4" : `<br/>Vos réunions sont vraiment les vôtres. <b>Unpen ne vend pas, ne partage pas et n'utilise pas vos données</b> à d'autres fins que la fourniture de nos services.
            <br/><br/>
            <b>Toutes vos données sont stockées et traitées dans l'UE. </b> Pour garantir la confidentialité de vos données, chaque réunion est chiffré sur nos serveurs.`,
    "p5" : "Tester Unpen gratuitement",
    "calltoaction1" : "Tester Unpen gratuitement",
    "submitMail" : "Envoyer",
    "features" : "Fonctionnalités",
    "signup" : "Inscription",
    "signin" : "Connexion",
    "legalMention" : "Mentions légales",
    "editor": "Éditeur",
    "Hosting": "Hébergeur",
    "capital": "capital social",
    "FAQ_title1" : " Comment Unpen assure la sécurité et la confidentialité de mes réunions ?",
    "FAQ_title2" : "Unpen partage-t-il ou vend-il mes données à des tiers ?",
    "FAQ_title3" : "Où sont stockées mes données, et comment Unpen se conforme aux réglementations en matière de protection des données ?",
    "FAQ_title4" : "Quelles langues Unpen prend-il en charge ?",
    "FAQ_title5" : "Est-ce que je peux utiliser Unpen hors ligne ?",
    "FAQ_title6" : "Quelle est la durée maximale d'une réunion ?",
    "FAQ_title7" : "Comment puis-je partager une réunion avec mes collègues, clients ou partenaires ?",
    "FAQ_text1": "Chez Unpen, nous prenons très au sérieux la protection des données. Toutes les réunions sont chiffrés dans notre base de données, ce qui garantit que seuls vous puissiez y accéder. Nous utilisons des protocoles de chiffrage standard pour sécuriser vos données.",
    "FAQ_text2": "Non. Nous respectons la confidentialité de vos données et ne les partageons ni ne les vendons à quiconque.",
    "FAQ_text3": "Toutes les données traitées par Unpen sont stockées au sein de l'Union européenne (UE) conformément au Règlement général sur la protection des données (RGPD). Nous respectons une politique stricte de protection des données et suivons des procédures pour garantir que vos données personnelles soient traitées de manière responsable et sécurisée.",
    "FAQ_text4": "L'interface d'Unpen est actuellement disponible en français, anglais et espagnol. Cependant, notre système de intelligence artificielle peut traiter et comprendre le texte dans plusieurs langues, notamment l'anglais, le français, l'allemand, l'espagnol et l'italien. Nous travaillons à ajouter d'autres langues à la fois pour l'interface et les modèles de notre IA, alors restez à l'affût des mises à jour ! Notre objectif est de rendre Unpen accessible aux utilisateurs du monde entier, quel que soit leur choix de langue.",
    "FAQ_text5": "Vous pouvez uploader des fichiers audio (ou vidéo) enregistrés sur votre appareil une fois que vous vous reconnectez et nous les transcrirons et résumerons comme s'ils avaient été enregistrés en direct sur Unpen.",
    "FAQ_text6": "Il n'y a pas de limite à la durée d'une réunion.",
    "FAQ_text7": "Vous pouvez partager par mail le résumé, les points clés et/ou la transcription de la réunion en un clic.",
    "TOS": "CGU",
    "signupButton": "Continuer",
    "TOSCheckbox": "J'ai lu et j'accepte les <a href='https://unpen.eu/TOS_pdf/fr'>CGU</a> et les <a href='https://unpen.eu/CGV'>CGV</a>.",
    "pswConfirmLabel": "Confirmez le mot de passe",
    "pswLabel": "Mot de passe",
    "psw": "Mot de passe",
    "psw2": "Confirmez le mot de passe",
    "emailLabel": "Adresse email",
    "email": "Mon adresse email",
    "SignUpTitle": "Inscription",
    "hero_title": "Améliorez vos réunions avec Unpen",
    "hero_description": "Révolutionnez vos réunions avec l'enregistrement, la transcription et la synthèse propulsés par l'IA.",
    "get_started": "Commencer",
    "sign_in": "Connexion",
    "sign_up_title": "Inscription",
    "email_label": "Email",
    "password_label": "Mot de passe",
    "submit": "Soumettre",
    "forgotPassword": "Mot de passe oublié ?",
    "resetPasswordInstructions": "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "sendResetLink": "Envoyer le lien",
    "resetLinkSent": "Lien envoyé !",
    "checkEmailInstructions": "Veuillez consulter votre e-mail pour obtenir les instructions de réinitialisation de votre mot de passe.",
    "backToLogin": "Retour à",
    "noAccount": "Vous n'avez pas de compte ?",
    "createAccount": "Créer un compte",
    "alreadyHaveAccount": "Vous avez déjà un compte ?",
    "faq_title": "Questions fréquemment posées",
    "slide1_title": "Économisez votre ressource la plus précieuse : votre temps",
    "slide1_content": "Unpen vous libère de la prise de notes et de la rédaction de comptes-rendu lors de vos réunion et interviews afin que vous puissiez vous concentrer sur le reste de votre travail.",
    "slide2_title": "Obtenez les points clés au fur et à mesure de la réunion",
    "slide2_content": "Unpen met en évidence les points importants à mesure que la réunion progresse.",
    "slide3_title": "Axé sur la vie privée",
    "slide3_content": "Vos réunions sont vraiment les vôtres. Unpen ne vend pas, ne partage pas et n'utilise pas vos données à d'autres fins que la fourniture de nos services.",
    "faq1_question": "Comment Unpen assure la sécurité et la confidentialité de mes réunions ?",
    "faq1_answer": "Chez Unpen, nous prenons très au sérieux la protection des données. Toutes les réunions sont chiffrés dans notre base de données, ce qui garantit que seuls vous puissiez y accéder. Nous utilisons des protocoles de chiffrage standard pour sécuriser vos données.",
    "faq2_question": "Unpen partage-t-il ou vend-il mes données à des tiers ?",
    "faq2_answer": "Non. Nous respectons la confidentialité de vos données et ne les partageons ni ne les vendons à quiconque.",
    "faq3_question": "Où sont stockées mes données, et comment Unpen se conforme aux réglementations en matière de protection des données ?",
    "faq3_answer": "Toutes les données traitées par Unpen sont stockées au sein de l'Union européenne (UE) conformément au Règlement général sur la protection des données (RGPD). Nous respectons une politique stricte de protection des données et suivons des procédures pour garantir que vos données personnelles soient traitées de manière responsable et sécurisée.",
    "faq4_question": "Quelles langues Unpen prend-il en charge ?",
    "faq4_answer": "L'interface d'Unpen est actuellement disponible en français, anglais et espagnol. Cependant, notre système de intelligence artificielle peut traiter et comprendre le texte dans plusieurs langues, notamment l'anglais, le français, l'allemand, l'espagnol et l'italien.",
};

export const spanishTxt = {
	"title1" : "Ahorra en el recurso más valioso: el tiempo",
	"title1bis" : "Potencia tus reuniones con la Inteligencia Artificial",
	"title2" : "Accede a los puntos clave en cualquier momento",
	"title3" : "Recupera tu reunión siempre que lo necesites",
	"title4" : "Privacidad: nuestra prioridad",
	"title5" : "Conéctate con nosotros",
	"p1" : `Con Unpen no necesitas tomarte la molestia de tomar notas y redactar informes. Así puedes concentrarte en lo importante: hacerlo todo.`,
	"p1bis" : `Unpen es su solución todo en uno para grabar, resumir y redactar actas de sus reuniones presenciales con una precisión y facilidad inigualables.
			<br/><br/>
			Con Unpen, no te preocuparás por olvidar nada importante en tus reuniones. La información queda registrada para siempre.`,
	"p2" : `Unpen resalta en tiempo real los aspectos más importantes de la reunión.`,
	"p3" : `Con Unpen, puedes trabajar juntos de inmediato, sin necesidad de configuraciones ni instalaciones complejas. La colaboración se vuelve fluida y eficiente.
			<br/><br/>
			Envía resúmenes de reuniones o proyectos a tu equipo a través de correo electrónico con Unpen.
			`,
	"p4" : `<br/>Tus reuniones son completamente privadas con Unpen. No compartimos, vendemos ni usamos tu información para otros fines que ofrecer nuestros servicios.
			<br/><br/>
			<b>Tus datos son tratados y guardados dentro de la Unión Europea.<br/>
				Unpen garantiza la seguridad de tus reuniones cifrando cada una de ellas en nuestros servidores`,
	"p5" : "Prueba Unpen gratuitamente",
	"calltoaction1" : "Prueba Unpen gratuitamente",
	"submitMail" : "Enviar correo electrónico",
	"features" : "Funcionalidades",
	"signup" : "Inscríbete",
	"signin" : "Inicia sesión",
	"legalMention": "Información jurídica",
	"editor": "Publicador",
	"Hosting": "Servidor web",
	"capital": "Capital social",
	"FAQ_title1" : "¿Qué medidas de seguridad y confidencialidad tiene Unpen para proteger mis reuniones?",
	"FAQ_title2" : "¿Cómo utiliza Unpen mis datos personales? ¿La comparte con terceros?",
	"FAQ_title3" : "¿Dónde se guardan mis datos en Unpen? ¿Cómo aseguran que se cumplan las normas de protección de datos y la seguridad de mi información personal?",
	"FAQ_title4" : "¿En qué idiomas se puede utilizar Unpen?",
	"FAQ_title5" : "¿Es posible usar Unpen en modo offline?",
	"FAQ_title6" : "¿Cuál es el máximo duración de una reunión?",
	"FAQ_title7" : "¿Cómo puedo compartir una reunión con mis colegas, clientes o socios?",
	"FAQ_text1": "En Unpen, nos comprometemos a proteger tu privacidad y seguridad. Todas las transcripciones, resúmenes y puntos clave de las reuniones están cifradas en nuestra base de datos, garantizando que solo tú puedas acceder a ellas. Utilizamos tecnologías de cifrado avanzadas para asegurar la integridad y confidencialidad de tus datos.",
	"FAQ_text2": "Absolutamente no. Respetamos la confidencialidad de tus datos y no los compartimos ni vendemos a nadie. Tus datos se utilizan exclusivamente para ayudarte a tener reuniones más productivas.",
	"FAQ_text3": "Unpen almacena todos los datos dentro del territorio europeo, en cumplimiento con la normativa europea de protección de datos (RGPD). Nuestros equipos se comprometen a proteger tus datos personales de manera responsable y segura, según estrictas políticas y procedimientos.",
	"FAQ_text4": "La interfaz de Unpen actualmente está disponible en español, inglés y francés. Sin embargo, nuestro sistema de inteligencia artificial puede procesar y entender texto en varios idiomas, incluyendo inglés, francés, alemán, español e italiano. Estamos trabajando en agregar más idiomas tanto a la interfaz como a nuestros modelos de AI, así que mantén el ojo abierto por actualizaciones! Nuestro objetivo es hacer que Unpen sea accesible para usuarios de todo el mundo, sin importar su idioma.",
	"FAQ_text5": "Cuando vuelves a tener conexión a Internet, podrás subir los archivos de audio o video que registraste mientras estabas desconectado y nosotros te transcribiremos y resumiremos como si hubieran sido grabados en vivo en Unpen.",
	"FAQ_text6": "No hay límite en la duración de una reunión en Unpen.",
	"FAQ_text7": "Podrás compartir con facilidad el resumen, los puntos clave y/o la transcripción de la misma por correo electrónico.",
    "TOS": "Términos y Condiciones",
    "signupButton": "registrarse",
    "TOSCheckbox": "He leído y acepto los  <a href='https://unpen.eu/TOS_pdf/es'>TOS</a> y <a href='https://unpen.eu/CGV'>condiciones de venta</a>.",
    "pswConfirmLabel": "Confirmar contraseña",
    "pswLabel": "Contraseña",
    "psw": "Contraseña",
    "psw2": "Confirmar contraseña",
    "emailLabel": "Correo electrónico",
    "email": "Correo electrónico",
    "SignUpTitle": "Registrarse",
    "hero_title": "Mejore sus reuniones con Unpen",
    "hero_description": "Revolucione sus reuniones con grabación, transcripción y resumen impulsados por IA.",
    "get_started": "Empezar",
    "sign_in": "Iniciar sesión",
    "sign_up_title": "Registrarse",
    "email_label": "Correo electrónico",
    "password_label": "Contraseña",
    "submit": "Enviar",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "resetPasswordInstructions": "Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
    "sendResetLink": "Enviar enlace",
    "resetLinkSent": "¡Enlace enviado!",
    "checkEmailInstructions": "Por favor, revisa tu correo electrónico para obtener instrucciones sobre cómo restablecer tu contraseña.",
    "backToLogin": "Volver a",
    "noAccount": "¿No tienes una cuenta?",
    "createAccount": "Crear cuenta",
    "alreadyHaveAccount": "¿Ya tienes una cuenta?",
    "faq_title": "Preguntas frecuentes",
    "slide1_title": "Ahorra en el recurso más valioso: el tiempo",
    "slide1_content": "Con Unpen no necesitas tomarte la molestia de tomar notas y redactar informes. Así puedes concentrarte en lo importante: hacerlo todo.",
    "slide2_title": "Accede a los puntos clave en cualquier momento",
    "slide2_content": "Unpen resalta en tiempo real los aspectos más importantes de la reunión.",
    "slide3_title": "Privacidad: nuestra prioridad",
    "slide3_content": "Tus reuniones son completamente privadas con Unpen. No compartimos, vendemos ni usamos tu información para otros fines que ofrecer nuestros servicios.",
    "faq1_question": "¿Qué medidas de seguridad y confidencialidad tiene Unpen para proteger mis reuniones?",
    "faq1_answer": "En Unpen, nos comprometemos a proteger tu privacidad y seguridad. Todas las transcripciones, resúmenes y puntos clave de las reuniones están cifradas en nuestra base de datos, garantizando que solo tú puedas acceder a ellas. Utilizamos tecnologías de cifrado avanzadas para asegurar la integridad y confidencialidad de tus datos.",
    "faq2_question": "¿Cómo utiliza Unpen mis datos personales? ¿La comparte con terceros?",
    "faq2_answer": "Absolutamente no. Respetamos la confidencialidad de tus datos y no los compartimos ni vendemos a nadie. Tus datos se utilizan exclusivamente para ayudarte a tener reuniones más productivas.",
    "faq3_question": "¿Dónde se guardan mis datos en Unpen? ¿Cómo aseguran que se cumplan las normas de protección de datos y la seguridad de mi información personal?",
    "faq3_answer": "Unpen almacena todos los datos dentro del territorio europeo, en cumplimiento con la normativa europea de protección de datos (RGPD). Nuestros equipos se comprometen a proteger tus datos personales de manera responsable y segura, según estrictas políticas y procedimientos.",
    "faq4_question": "¿En qué idiomas se puede utilizar Unpen?",
    "faq4_answer": "La interfaz de Unpen actualmente está disponible en español, inglés y francés. Sin embargo, nuestro sistema de inteligencia artificial puede procesar y entender texto en varios idiomas, incluyendo inglés, francés, alemán, español e italiano.",
};

// Function to get user's language
export const getLang = () => {
  // Check if URL contains language specifier
  if (window.location.href.indexOf("/en") !== -1) {
    return "en";
  }
  if (window.location.href.indexOf("/es") !== -1) {
    return "es";
  }
  if (window.location.href.indexOf("/fr") !== -1) {
    return "fr";
  }
  
  // Otherwise check browser language
  const userLang = navigator.language || navigator.userLanguage;
  if (userLang.startsWith("fr")) {
    return "fr";
  }
  if (userLang.startsWith("es")) {
    return "es";
  }
  
  // Default to English
  return "en";
};

// Function to get translated text based on key and language
export const getText = (id, language = null) => {
  const lang = language || getLang();
  
  if (lang === "fr") {
    return frenchTxt[id] || englishTxt[id];
  }
  if (lang === "es") {
    return spanishTxt[id] || englishTxt[id];
  }
  
  return englishTxt[id];
};

// Function to update document title based on language
export const updateTitle = () => {
  const lang = getLang();
  
  if (lang === "fr") {
    document.title = "Unpen - pour des réunions plus efficaces";
  } else if (lang === "es") {
    document.title = "Unpen - para reuniones más efectivas";
  } else {
    document.title = "Unpen - embrace better meetings";
  }
};

// HTML parser to handle HTML content in translation strings
export const parseHTML = (html) => {
  if (!html) return '';
  return { __html: html };
}; 